import React, { useState } from 'react'
import styled from '@emotion/styled'
import { rem } from 'polished'
import { Box } from 'components'
import MapContainer, { IMapContainerProps } from './Map'
import { useJsApiLoader } from '@react-google-maps/api'
import { GOOGLE_MAPS_HOOK_PROPS } from 'utils'

const StyledBox = styled(Box)`
  .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom {
    top: 0;
  }

  border-radius: 8px;
  overflow: hidden;

  z-index: 1;
  position: sticky;

  height: ${rem(200)};
`

const Placeholder = styled(StyledBox)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e9edf2;
`

const ShowMapButton = styled('button')`
  cursor: pointer;
  padding: ${rem(10)} ${rem(20)};
  border: none;
  border-radius: 8px;
  background-color: #2b2f6b;
  color: #fff;
  font-size: ${rem(15)};
  font-weight: 600;
`

const MapLoader = ({ ...props }: IMapContainerProps) => {
  const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_HOOK_PROPS)

  return isLoaded ? (
    <StyledBox>
      <MapContainer {...props} />
    </StyledBox>
  ) : null
}

export const Map = ({ ...props }: IMapContainerProps) => {
  const [showMap, setShowMap] = useState(false)

  if (showMap) {
    return <MapLoader {...props} />
  }

  return (
    <Placeholder>
      <ShowMapButton type="button" onClick={() => setShowMap(true)}>
        Show map
      </ShowMapButton>
    </Placeholder>
  )
}
